import account from './account';
import collections from './collections';
import dashboard from './dashboard';
import ecbaNavigation from './ecbaNavigation';
import lfpNavigation from './lfpNavigation';
import referrals from './referrals';
import reports from './reports';

const leftMenuNavigatoin = [
    ...dashboard,
    ...referrals,
    ...account,
    ...collections,
    ...ecbaNavigation,
    ...lfpNavigation,
    ...reports,
];

export default leftMenuNavigatoin;
